import {Navigate, Outlet, useLocation, useParams} from 'react-router-dom';
import {
  DEFAULT_PROVIDER,
  getProvider,
  providerHomePath,
  resolveProviderRoute,
} from '@/config/providers';

/**
 * Validates the `:providerId` segment and keeps provider and section in sync.
 * The decision itself lives in `resolveProviderRoute` so it can be tested
 * without mounting a router.
 */
export function ProviderLayout() {
  const {providerId} = useParams<{providerId: string}>();
  const location = useLocation();

  const redirectTo = resolveProviderRoute(providerId, location.pathname);
  if (redirectTo) return <Navigate to={redirectTo} replace />;

  return <Outlet />;
}

/**
 * Index route under `:providerId` — sends a bare `/tungsten` to whichever
 * section that provider's kind actually has.
 */
export function ProviderHomeRedirect() {
  const {providerId} = useParams<{providerId: string}>();
  const provider = getProvider(providerId) ?? DEFAULT_PROVIDER;
  return <Navigate to={providerHomePath(provider)} replace />;
}
